export enum PaymentMethod {
    CARD,
    BACS
}
